@if (boxes(); as boxes) {
  @if (shouldShowAsCarousel()) {
    <p-carousel
      [autoplayInterval]="5000"
      [circular]="true"
      [numScroll]="1"
      [numVisible]="3"
      [responsiveOptions]="responsiveOptions()"
      [showIndicators]="false"
      [value]="boxes">
      <ng-template
        #item
        let-box>
        <app-public-boxes-carousel-tile
          [imageSrc]="box.imageSrc"
          [slug]="box.slug"
          [imageAlt]="box.imageAlt"
          [sales]="box.sales"
          [name]="box.name"
          class="px-4" />
      </ng-template>
    </p-carousel>
  } @else {
    <div class="flex w-full justify-center gap-8">
      @for (box of boxes; track box.id) {
        <div class="basis-full sm:basis-1/3">
          <app-public-boxes-carousel-tile
            [imageSrc]="box.imageSrc"
            [slug]="box.slug"
            [imageAlt]="box.imageAlt"
            [sales]="box.sales"
            [name]="box.name" />
        </div>
      }
    </div>
  }
} @else {
  <app-spinner-filled />
}
